export const civilStatus = [
  { id: 1, name: 'Solteiro(a)' },
  { id: 2, name: 'Casado(a)' },
  { id: 3, name: 'Viúvo(a)' },
  { id: 4, name: 'União estável' },
  { id: 5, name: 'Divorciado(a)' },
  { id: 6, name: 'Outros' },
];
